import React from 'react';

export default function TitleCard({ children }) {
	return (
		<h2 className="white font-semibold xl:text-2xl w-full text-center">
			{children}
		</h2>
	);
}
